import { useState, useEffect, useCallback } from "react";
import { getContainerHeight, getContainerHeightPercentage } from "../helpers/fetching";

const useContainerHeight = (currentEnv, remainingHeight) => {
  const getHeight = useCallback(
    () =>
      remainingHeight !== undefined
        ? getContainerHeight(currentEnv, remainingHeight)
        : getContainerHeightPercentage(currentEnv),
    [currentEnv, remainingHeight]
  );

  const [containerHeight, setContainerHeight] = useState(getHeight);

  useEffect(() => {
    const handleResize = () => setContainerHeight(getHeight());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [getHeight]);

  return containerHeight;
};

export default useContainerHeight;
